import { Container } from 'react-bootstrap';
import {
  SectionHeadingMed,
  HeadingDesc,
  SubSectionHeading
} from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import img1 from '../../../assets/images/png/healthicon1.png';
import img2 from '../../../assets/images/png/healthicon2.png';
import img3 from '../../../assets/images/png/healthicon3.png';
import img4 from '../../../assets/images/png/healthicon4.png';
import img5 from '../../../assets/images/png/backpain.png';
import './healthConditions.css';

function HealthConditions() {
  return (
    <section className="section">
      <Container className="healthConditions">
        <div className="large box">
          <div>
            <SectionHeadingMed text="Sehat A to Z" />
            <HeadingDesc text="Learn more about common and complex health ailments and conditions." />
            <SimpleButton text="VIEW ALL" />
          </div>
        </div>
        <div className="medium box bg_tifannyblue">
          <SubSectionHeading text="Back Pain" color="#FFFFFF" />
          <div className="box_img">
            <img src={img5} alt="" />
          </div>
        </div>
        <div className="large box bg_green">
          <SubSectionHeading text="Breast Cancer" color="#FFFFFF" />
          <div className="box_img">
            <img src={img4} alt="" />
          </div>
        </div>
        <div className="large box bg_rosepink">
          <SubSectionHeading text="Oral Health" color="#FFFFFF" />
          <div className="box_img">
            <img src={img2} alt="" />
          </div>
        </div>
        <div className="medium box bg_tifannyblue_light">
          <SubSectionHeading text="Autism" color="#313131" />
          <div className="box_img">
            <img src={img3} alt="" />
          </div>
        </div>
        <div className="medium box bg_yellow">
          <SubSectionHeading text="Diabetes" color="#313131" />
          <div className="box_img">
            <img src={img1} alt="" />
          </div>
        </div>
      </Container>
    </section>
  );
}

export default HealthConditions;
